export default {
  title: 'Assets',
  'menu.triggers': 'Triggers',
  'menu.fields': 'Customize add Fields',

  'menu.qrcode': 'QR Code generator',
  'menu.buckets': 'QR Code buckets history',
  name: 'Name',
  type: 'Type',
  enabled: 'Enabled',
  fields: {
    NAME: 'Name',
    PLACE_NAME: 'Place/Person/Fleet',
    TYPE_NAME: 'Type'
  }
}
